"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVault = void 0;
const types_1 = require("@shapeshiftoss/types");
const lodash_1 = require("lodash");
const __1 = require("..");
const transformVault = (vault) => {
    return {
        ...vault,
        vaultAddress: (0, lodash_1.toLower)(vault.address),
        name: `${vault.name} ${vault.version}`,
        symbol: vault.symbol,
        tokenAddress: (0, lodash_1.toLower)(vault.token),
        chain: types_1.ChainTypes.Ethereum,
        provider: __1.DefiProvider.Yearn,
        type: __1.DefiType.Vault,
        expired: vault.metadata.depositsDisabled || (0, __1.bnOrZero)(vault.metadata.depositLimit).lte(0)
    };
};
exports.transformVault = transformVault;
